import React, { useEffect, useState } from "react";
import TopBar from "../../components/TopBar";
import { auth, db } from "../../utils/firebase";
import { collectionNames, routes } from "../../utils/Constants";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
const Profile = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState({});
  const getProfileDetails = async () => {
    const email = auth.currentUser.email;
    const docRef = doc(db, collectionNames.STAFFS, email);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setUser({ id: docSnap.id, ...docSnap.data() });
    } else {
      return alert("No User found");
    }
  };

  const logoutHandler = () => {
    const confirm = window.confirm("Are you sure want to logout ?");
    if (!confirm) return;
    auth.signOut();
    navigate(routes.LOGIN);
  };

  useEffect(() => {
    getProfileDetails();
  }, []);
  return (
    <div>
      <TopBar title="Profile" />
      <div className="flex h-[80vh] flex-col items-center justify-center">
        <p>{user.email}</p>
        <p
          className="mt-2 underline text-blue-500 cursor-pointer"
          onClick={logoutHandler}
        >
          Logout
        </p>
      </div>
    </div>
  );
};

export default Profile;
